const blue = "#4a90e2";

const grayDarkest = "#3d4853";
const grayDarker = "#596067";
const grayDark = "#7e888e";
const gray = "#a2acb3";

const colors = { blue, grayDarkest, gray, grayDarker, grayDark };

export { colors };



// WEBPACK FOOTER //
// ./app/javascript/styles/index.ts